import React from "react";
import {Money} from "../../../../api-client";
import {Money as MoneyComponent} from "../../../common";
import styles from "./UpcomingReceipts.module.scss";
import {useMyMoneyData} from "../../../../hooks/useMyMoneyData";

export const UpcomingReceipts = () => {
  const {days30, days90, days60} = useMyMoneyData().nextRepaymentsSum;
  const data = [
    {period: '30 дней', amount: days30},
    {period: '60 дней', amount: days60},
    {period: '90 дней', amount: days90},
  ];

  return (
    <div className={styles.receipts}>
      <h3 className={styles.receipts__title}>Ближайшие поступления</h3>
      <ul className={styles.receipts__list}>
        {data.map((item, index) => (
          <li key={index} className={styles.receipts__item}>
            <span className={styles.receipts__period}>{item.period}</span>
            <MoneyComponent money={item.amount}/>
          </li>
        ))}
      </ul>
    </div>
  );
};